import { render, staticRenderFns } from "./ArticleCategory.vue?vue&type=template&id=55457f1b&scoped=true&"
import script from "./ArticleCategory.vue?vue&type=script&lang=js&"
export * from "./ArticleCategory.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCategory.vue?vue&type=style&index=0&id=55457f1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55457f1b",
  null
  
)

export default component.exports